import React, { useMemo } from 'react';
import { classes } from '../GooglePreview.st.css';
import { dataHooks } from '../constants';
import { GooglePreviewProps } from '../GooglePreview.types';
import { GooglePreviewFavicon } from './GooglePreviewFavicon';

import { Text } from '../../Text';
import { Tooltip } from '../../Tooltip';
import { replaceSlash } from '../GooglePreviewUtils';

interface GooglePreviewWebsiteInfoProps {
  previewUrl: GooglePreviewProps['previewUrl'];
  favicon: GooglePreviewProps['favicon'];
  siteName: GooglePreviewProps['siteName'];
  onClick: GooglePreviewProps['onWebsiteInfoClick'];
  tooltipContent: GooglePreviewProps['websiteInfoTooltipContent'];
  tooltipProps: GooglePreviewProps['websiteInfoTooltipProps'];
}

export const GooglePreviewWebsiteInfo: React.FC<
  GooglePreviewWebsiteInfoProps
> = ({
  previewUrl,
  favicon,
  siteName,
  onClick,
  tooltipContent,
  tooltipProps,
}) => {
  const formattedUrl = useMemo(() => replaceSlash(previewUrl), [previewUrl]);
  return (
    <button
      onClick={onClick}
      data-hook={dataHooks.GooglePreviewWebsiteInfo}
      className={classes.googlePreviewWebsiteInfoCTA}
    >
      <Tooltip
        content={tooltipContent}
        disabled={!tooltipContent}
        {...tooltipProps}
        dataHook={dataHooks.GooglePreviewWebsiteInfoTooltip}
      >
        <div className={classes.googlePreviewWebsiteInfo}>
          <GooglePreviewFavicon faviconUrl={favicon} />
          <div className={classes.googlePreviewWebsiteInfoContent}>
            <Text
              weight="thin"
              size="tiny"
              light={false}
              secondary={false}
              className={classes.googlePreviewSiteName}
              dataHook={dataHooks.GooglePreviewSiteName}
              ellipsis
              showTooltip={false}
            >
              {siteName}
            </Text>
            <Text
              weight="thin"
              size="tiny"
              light={false}
              className={classes.googlePreviewUrl}
              dataHook={dataHooks.GooglePreviewPreviewUrl}
              ellipsis
              showTooltip={false}
            >
              {formattedUrl}
            </Text>
          </div>
        </div>
      </Tooltip>
    </button>
  );
};
